import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { AiFillPrinter } from "react-icons/ai";
import { connect } from "react-redux";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { getGradeList } from "../../actions/Grade.action";
import { years } from "../../constants/MonthsAndYears";
import { getGrade } from "../../utils/getGrade";
import {
  getTermCountOptions,
  getTermLabel,
  getTermOptions,
} from "../../utils/coachingPerformance";
import SectionHeading from "../SectionHeading/SectionHeading";
import { getAllSchoolPerformance } from "../../actions/SchoolPerformance.action";
import styles from "../CoachingPerformanceViewResults/CoachingPerformanceViewResults.module.css";

const SchoolPerformanceViewResults = ({
  list,
  getGradeList,
  extra,
  grades,
  getAllSchoolPerformance,
}) => {
  const [rawList, setRawList] = useState(list === null ? [] : list);
  const [grade, setGrade] = useState("");
  const [batch, setBatch] = useState("");
  const [shift, setShift] = useState("");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [termCount, setTermCount] = useState("");
  const [term, setTerm] = useState("");

  const ref = useRef(null);

  const gradeCalculate = (status) => {
    if (rawList) {
      let count = 0;
      rawList.forEach((item) => {
        if (
          item?.schoolPerformances.length > 0 &&
          getGrade(item?.schoolPerformances[0]?.percent.toFixed(0)) === status
        ) {
          count++;
        }
      });
      return count;
    }
    return 0;
  };

  useEffect(() => {
    if (grades === null) {
      getGradeList();
    }
    if (list !== null) {
      setRawList(list);
    }
  }, [getGradeList, grades, list]);

  const selectHandeler = async () => {
    if (!term) {
      return;
    }
    await getAllSchoolPerformance(batch, year, term, grade, shift);
  };

  const termOptions = termCount ? getTermOptions(parseInt(termCount)) : [];

  return (
    <Container className="pb-4">
      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="grade" className="d-block">
                  Class
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setBatch("");
                  setShift("");
                  setGrade(e.target.value);
                }}
              >
                <option value={""}>Select Class</option>
                {grades &&
                  grades.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            {grades && grade !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="shift" className="d-block">
                    Shift
                  </label>
                </div>
                <Form.Select
                  onChange={(e) => {
                    setBatch("");
                    setShift(e.target.value);
                  }}
                >
                  <option value={""}>Select Shift</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .shifts.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="batch" className="d-block">
                    Batch
                  </label>
                </div>
                <Form.Select onChange={(e) => setBatch(e.target.value)}>
                  <option value={""}>Select Batch</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .batches.filter((bt) => bt.shiftId === parseInt(shift))
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" ? (
              <Col
                md={3}
                className="d-md-flex d-none jsutify-content-end align-items-end py-3"
              >
                <Button
                  onClick={selectHandeler}
                  variant="primary"
                  type="submit"
                  className="btn_primary"
                >
                  Select
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="termCount" className="d-block">
                  Term Count (Optional)
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setTermCount(e.target.value);
                  if (
                    term &&
                    e.target.value &&
                    parseInt(term) > parseInt(e.target.value)
                  ) {
                    setTerm("");
                  }
                }}
                id="termCount"
                name="termCount"
                value={termCount}
              >
                <option value={""}>All</option>
                {getTermCountOptions().map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="term" className="d-block">
                  Term Type
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setTerm(e.target.value);
                }}
                id="term"
                name="term"
                value={term}
              >
                <option value={""}>Select Term Type</option>
                {termCount
                  ? termOptions.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))
                  : getTermOptions(2)
                      .concat(getTermOptions(3))
                      .filter(
                        (v, i, a) =>
                          a.findIndex((t) => t.value === v.value) === i
                      )
                      .map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
              </Form.Select>
            </Col>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="year" className="d-block">
                  Year
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="year"
                name="year"
                value={year}
              >
                {years.map((item, i) => (
                  <option key={i} value={`${item}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col
              md={4}
              className="d-flex d-md-none jsutify-content-end align-items-end py-3"
            >
              <Button
                onClick={selectHandeler}
                variant="primary"
                type="submit"
                className="btn_primary"
              >
                Select
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {rawList !== null ? (
        <Card className="crd p-md-2 pb-md-0 p-2 mt-4">
          <Card.Body>
            {rawList === null ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: 600 }}
              >
                <Spinner variant="dark" animation="grow" />
              </div>
            ) : rawList.length === 0 ? (
              <span className="text-center fs-4 d-block pb-3">
                No School Performance Found
              </span>
            ) : (
              <div ref={ref} className={styles.print}>
                <div className="d-flex justify-content-end ">
                  <div className="">
                    <ReactToPrint
                      documentTitle={`School Performance Marksheet - ${rawList[0].batch.name} `}
                      content={() => ref.current}
                    >
                      <PrintContextConsumer>
                        {({ handlePrint }) => (
                          <span
                            className={styles.chart_icon}
                            onClick={handlePrint}
                          >
                            <AiFillPrinter />
                          </span>
                        )}
                      </PrintContextConsumer>
                    </ReactToPrint>
                  </div>
                </div>
                <div className="px-3">
                  <SectionHeading
                    title={`${getTermLabel(
                      extra?.termCount || termCount || 2,
                      extra?.term || term
                    )} ${extra?.year || year} School Performance Report`}
                    customClass={styles.heading}
                  />

                  <div className="d-flex align-items center justify-content-center">
                    <div className="d-flex justify-content-center ">
                      <span className="d-block pe-3">
                        <span className="fw-bold">A++</span> = (91-100)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A+</span> = (81-90)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A</span> = (71-80)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A-</span> = (61-70)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">B</span> = (51-60)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">C</span> = {"(<51)"}
                      </span>
                    </div>
                  </div>
                  <Table bordered responsive striped className="mt-3">
                    <thead>
                      <tr>
                        <th>UID</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Percentage</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rawList.map((markItem) => (
                        <tr key={markItem.id}>
                          <td>{markItem.uid}</td>
                          <td>{markItem.name}</td>
                          <td>{markItem.phone}</td>
                          <td>
                            {markItem.schoolPerformances.length > 0
                              ? markItem.schoolPerformances[0].percent.toFixed(0) +
                                "%"
                              : ""}
                          </td>
                          <td>
                            {markItem.schoolPerformances.length > 0
                              ? getGrade(
                                  markItem.schoolPerformances[0].percent.toFixed(0)
                                )
                              : ""}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={2} className="fw-bold">
                          Summary
                        </td>
                        <td>A++: {gradeCalculate("A++")}</td>
                        <td>A+: {gradeCalculate("A+")}</td>
                        <td>A: {gradeCalculate("A")}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  list: state.schoolPerformance.all,
  extra: state.schoolPerformance.extra,
  grades: state.grade.grade,
});

export default connect(mapStateToProps, {
  getGradeList,
  getAllSchoolPerformance,
})(SchoolPerformanceViewResults);
